import { render, staticRenderFns } from "./RecuperaSaldosGrid.vue?vue&type=template&id=330ce25e&scoped=true&"
import script from "./RecuperaSaldosGrid.vue?vue&type=script&lang=js&"
export * from "./RecuperaSaldosGrid.vue?vue&type=script&lang=js&"
import style0 from "./RecuperaSaldosGrid.vue?vue&type=style&index=0&id=330ce25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ce25e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330ce25e')) {
      api.createRecord('330ce25e', component.options)
    } else {
      api.reload('330ce25e', component.options)
    }
    module.hot.accept("./RecuperaSaldosGrid.vue?vue&type=template&id=330ce25e&scoped=true&", function () {
      api.rerender('330ce25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Materiais/RecuperaSaldosGrid.vue"
export default component.exports